import { render, staticRenderFns } from "./InfoCreatingClient.vue?vue&type=template&id=7b4118d1&scoped=true&"
import script from "./InfoCreatingClient.vue?vue&type=script&lang=js&"
export * from "./InfoCreatingClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4118d1",
  null
  
)

export default component.exports